
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class SpiralGalaxyEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time } = pc;
        const count = Math.floor(200 * (config.parallaxComplexity || 1.0));
        const curTime = time * 0.5 * config.parallaxSpeed;
        
        ctx.fillStyle = pc.color;

        const draw = () => {
            ctx.beginPath();
            for (let i = 0; i < count; i++) {
                const angle = i * 0.1 + curTime + layerIndex;
                const r = i * 5 * (config.parallaxScale || 1.0);
                const px = Math.cos(angle) * r;
                const py = Math.sin(angle) * r;
                const size = 2 * (config.parallaxScale || 1.0);
                ctx.moveTo(px + size, py);
                ctx.arc(px, py, size, 0, Math.PI * 2);
            }
            ctx.fill();
        };
        draw();
        this.applyGlow(pc, draw);
    }
}
